export default __webpack_public_path__ + "static/media/africalogo.0d94115a.png";